import { Table } from "antd";
import { IoTrashBinOutline } from "react-icons/io5";
import { FiEdit } from "react-icons/fi";
import Manage from "..";
import { useEffect, useState } from "react";
import UpdateCustomer from "./components/UpdateCustomer";
import DeleteCustomer from "./components/DeleteCustomer";
import CreateCustomer from "./components/CreateCustomer";
import CreateWrapper from "./components/CreateWrapper";
import fetchAllContacts from "../../../services/fetchAllContacts";
import PageHeader from "../../../components/shared/PageHeader";

export default function NewCustomers() {
  const [createModal, setCreateModal] = useState(false);
  const [updateModal, setUpdateModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [selected, setSelected] = useState({});
  const [customers, setCustomers] = useState([]);
  const [isLoading, setLoading] = useState(false);

  const handleFetchCustomers = async () => {
    setLoading(true);
    const data = await fetchAllContacts();
    setLoading(false);
    setCustomers(data?.payload);
  };

  useEffect(() => {
    handleFetchCustomers();
  }, []);

  const columns = [
    {
      title: "S/N",
      width: 60,
      render: (record: any, text: any, index: any) => (
        <span className="text-gray-700 ml-2">{index + 1}</span>
      ),
    },
    {
      title: "Name",
      width: 150,
      render: (record: any) => (
        <span className="text-gray-700">
          {record?.customer?.name === null ? "-" : record?.customer?.name}
        </span>
      ),
    },
    {
      title: "Address",
      width: 380,
      render: (record: any) => (
        <span className="text-gray-700">
          {record?.customer?.address === null ? "-" : record?.customer?.address}
        </span>
      ),
    },
    {
      title: "Email",
      width: 150,
      render: (record: any) => (
        <span className="text-gray-700">
          {record?.customer?.email === null ? "-" : record?.customer?.email}
        </span>
      ),
    },
    {
      title: "Mobile",
      width: 150,
      render: (record: any) => (
        <span className="text-gray-700">
          {record?.customer?.phone === null ? "-" : record?.customer?.phone}
        </span>
      ),
    },
    {
      title: "Action",
      width: 80,
      render: (record: any) => (
        <div className="flex">
          <button
            onClick={() => {
              setSelected({
                record,
              });
              setUpdateModal(true);
            }}
            className="flex justify-center items-center text-gray-700 border rounded-md p-2 bg-gray-100 hover:bg-gray-200 cursor-pointer"
          >
            <FiEdit />
          </button>
          <button
            onClick={() => {
              setSelected({
                record,
              });
              setDeleteModal(true);
            }}
            className="flex justify-center items-center ml-1 text-gray-700 border rounded-md p-2 bg-red-100 hover:bg-red-200 cursor-pointer"
          >
            <IoTrashBinOutline />
          </button>
        </div>
      ),
    },
  ];

  return (
    <div className="flex flex-col border border-gray-300 mx-4 rounded-lg mt-2 bg-white">
      <div className="">
        <PageHeader
          title="Customers"
          subtitle="List of all customers"
          tag="List"
          hasLogo={true}
          actions={<CreateWrapper />}
        />
        <div className="grid gap-x-0 grid-cols-12">
          <div className="col-span-12 sm:col-span-12 md:col-span-12">
            <Table
              columns={columns}
              dataSource={customers}
              size="small"
              pagination={{ pageSize: 20 }}
              scroll={{ y: 425 }}
              rowKey="id"
            />

            <CreateCustomer
              isVisible={createModal}
              setCreateModal={setCreateModal}
              refetch={() => handleFetchCustomers()}
            />

            <UpdateCustomer
              customer={selected}
              isVisible={updateModal}
              setUpdateModal={setUpdateModal}
            />

            <DeleteCustomer
              selected={selected}
              isVisible={deleteModal}
              setDeleteModal={setDeleteModal}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
